import { Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { Chip } from 'components/chips'
import * as controllers from 'controllers'
import { CompanyDto, CompanyAddressDto } from 'dtos'
import { useEffect, useState } from 'react'
import BrokerInformationAddEditDialog from './BrokerInformationAddEditDialog'

//TODO: Add BrokerInformationCardProps
interface BrokerInformationCardProps {
  company: CompanyDto
}

//TODO: Add BrokerInformationCard
export default function BrokerInformationListCard({ company }: BrokerInformationCardProps) {
  const [isBrokerInformationSaving, setIsBrokerInformationSaving] = useState<boolean>(false)
  const [brokerInformationAddEditDialogOpen, setBrokerInformationAddEditDialogOpen] = useState<boolean>(false)

  const [isGettingBrokerCompanyAddress, setIsGettingBrokerCompanyAddress] = useState<boolean>(false)
  const [brokerCompanyAddress, setBrokerCompanyAddress] = useState<CompanyAddressDto | undefined>(undefined)
  const [needsEmail, setNeedsEmail] = useState<boolean>(false)
  const [needsPhone, setneedsPhone] = useState<boolean>(false)

  useEffect(() => {
    if (company && company.companyGuid) setIsGettingBrokerCompanyAddress(true)
    controllers
      .getBrokerCompanyAddress()
      .then(response => {
        const address = response.value
        setBrokerCompanyAddress(address)
        setNeedsEmail(!address?.email)
        setneedsPhone(!address?.phone)
      })
      .finally(() => {
        setIsGettingBrokerCompanyAddress(false)
      })
  }, [company])

  return (
    <>
      <BrokerInformationAddEditDialog
        onClose={() => {
          setBrokerInformationAddEditDialogOpen(false)
        }}
        onSave={values => {
          setIsBrokerInformationSaving(true)
        }}
        open={brokerInformationAddEditDialogOpen}
      />

      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h5'>
                  Broker Information
                </Typography>
              </Grid>
              {!brokerCompanyAddress && !isGettingBrokerCompanyAddress && (
                <Grid item xs={12} sm='auto'>
                  <Chip variant='red'>Needs Address</Chip>
                </Grid>
              )}
              {needsEmail && (
                <Grid item xs={12} sm='auto'>
                  <Chip variant='red'>Needs Email</Chip>
                </Grid>
              )}
              {needsPhone && (
                <Grid item xs={12} sm='auto'>
                  <Chip variant='red'>Needs Phone</Chip>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {isGettingBrokerCompanyAddress && (
              <Grid item container alignItems='center' justifyContent='center' sx={{ my: 1 }}>
                <Grid>
                  <CircularProgress color='primary' size={50} />
                </Grid>
              </Grid>
            )}

            <Grid item xs={12}>
              <ExplanationAccordion variant='outlined'>
                ||This card only shows if the company is marked as a Broker.||If there is no address, email, and/or phone number
                the card will indicate it via red text. ||
              </ExplanationAccordion>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
